(() => {
  const start = () => {
    const root = document.getElementById('scenic-collection-search');
    const native = document.getElementById('ProductGridContainer');
    if (!root || !native || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const input = root.querySelector('input');
    const clear = root.querySelector('button');
    const status = root.querySelector('[role="status"]');
    const results = document.createElement('div');
    results.className = 'collection page-width scenic-collection-search-results';
    results.hidden = true;
    native.after(results);
    const cache = new Map();
    let revision = 0;
    let timer;
    const normalize = text => text.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    const load = async () => {
      const url = new URL(location.href);
      url.searchParams.delete('page');
      url.searchParams.delete('section_id');
      const key = url.toString();
      if (cache.has(key)) return cache.get(key);
      const promise = (async () => {
        const grid = native.querySelector('#product-grid');
        if (!grid) throw new Error('Missing collection');
        url.searchParams.set('section_id', grid.dataset.id);
        const fetchPage = async page => {
          const pageUrl = new URL(url);
          pageUrl.searchParams.set('page', page);
          const response = await fetch(pageUrl.toString(), { credentials: 'same-origin' });
          if (!response.ok) throw new Error('Unable to load collection');
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          if (!html.querySelector('#ProductGridContainer')) throw new Error('Invalid collection response');
          return html;
        };
        const first = await fetchPage(1);
        const pageNumbers = [...first.querySelectorAll('#ProductGridContainer .pagination a[href]')].map(a => Number(new URL(a.href, location.origin).searchParams.get('page')) || 1);
        const total = Math.max(1, ...pageNumbers);
        const pages = [first];
        for (let page = 2; page <= total; page += 4) {
          const batch = Array.from({length: Math.min(4, total - page + 1)}, (_, i) => page + i);
          pages.push(...await Promise.all(batch.map(fetchPage)));
        }
        return {
          className: grid.className,
          cards: pages.flatMap(doc => [...doc.querySelectorAll('#product-grid > li')]).map(card => ({
            node: card,
            text: normalize(card.querySelector('.card__heading')?.textContent || card.textContent)
          }))
        };
      })();
      cache.set(key, promise);
      try { return await promise; }
      catch (error) { cache.delete(key); throw error; }
    };
    const search = async () => {
      const token = ++revision;
      const query = normalize(input.value.trim());
      document.documentElement.classList.toggle('scenic-searching-collection', Boolean(query));
      clear.hidden = !query;
      if (!query) {
        native.hidden = false;
        results.hidden = true;
        results.replaceChildren();
        results.removeAttribute('aria-busy');
        status.textContent = '';
        return;
      }
      native.hidden = true;
      results.hidden = false;
      results.replaceChildren();
      results.setAttribute('aria-busy', 'true');
      status.textContent = root.dataset.loading;
      try {
        const data = await load();
        if (token !== revision) return;
        const terms = query.split(/\s+/);
        const matches = data.cards.filter(card => terms.every(term => card.text.includes(term)));
        const list = document.createElement('ul');
        list.className = data.className;
        for (const card of matches) {
          const node = card.node.cloneNode(true);
          const ids = new Map();
          node.querySelectorAll('[id]').forEach(el => {
            const previousId = el.id;
            el.id = `${previousId}-collection-search`;
            ids.set(previousId, el.id);
          });
          for (const attribute of ['aria-labelledby', 'aria-describedby', 'aria-controls', 'aria-owns', 'for', 'form', 'list']) {
            node.querySelectorAll(`[${attribute}]`).forEach(el => {
              el.setAttribute(attribute, el.getAttribute(attribute).split(/\s+/).map(id => ids.get(id) || id).join(' '));
            });
          }
          for (const attribute of ['data-modal', 'href']) {
            node.querySelectorAll(`[${attribute}^="#"]`).forEach(el => {
              const target = el.getAttribute(attribute).slice(1);
              if (ids.has(target)) el.setAttribute(attribute, `#${ids.get(target)}`);
            });
          }
          node.querySelectorAll('img').forEach(img => { img.loading = 'lazy'; });
          list.append(node);
        }
        results.replaceChildren(list);
        document.dispatchEvent(new CustomEvent('scenic:collection-search-results'));
        status.textContent = matches.length ? `${matches.length} ${root.dataset.found}` : root.dataset.empty;
      } catch (error) {
        if (token !== revision) return;
        native.hidden = false;
        document.documentElement.classList.remove('scenic-searching-collection');
        results.hidden = true;
        status.textContent = root.dataset.error;
      } finally {
        if (token === revision) results.removeAttribute('aria-busy');
      }
    };
    input.addEventListener('input', () => { clearTimeout(timer); timer = setTimeout(search, 300); });
    root.querySelector('form').addEventListener('submit', event => { event.preventDefault(); clearTimeout(timer); search(); });
    clear.addEventListener('click', () => { input.value = ''; clearTimeout(timer); search(); input.focus(); });
    new MutationObserver(() => { if (input.value.trim()) { clearTimeout(timer); timer = setTimeout(search, 50); } }).observe(native, {childList: true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();


